import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import './image-module.scss';
import { isValid, isText } from '../../../../utils';

/* Logic:
- create empty array of stars, loop over it to populate to screen
- need to pass avgRating as prop from ContentModule.js
- loop over ratingsArray and check if current element is less than/equal to average:
  - if true, apply shaded in styling class
  - if false, apply non-shaded in styling class
- make sure radio inputs are set to disabled="true"

Styling notes:
Added stars styling to image-module.scss because styling is slightly different from recipe-styles.scss ratings stars
*/

const StarRating = (data) => {
  if (!isValid(data)) { return null; }
  const ratingsArray = [0,0,0,0,0];

  // Assigns a key and className to each star in the array
  const renderedAvgRating = ratingsArray.map((star, i) => {
    const labelId = `rating${i+1}`;
    let labelClass = (isValid(data.average) && ((!isNaN(data.average)) && (i < data.average))) ? "rating-label checked" : "rating-label";
    // returning this markup:
    return (
      <>
        <input type="radio" id={labelId} disabled="true" />
        <label className={labelClass} htmlFor={labelId} />
      </>
    );
  });

  return (
    <div className="rating-wrapper my-rating-wrapper">
      <fieldset id="avg-rating" className="star-wrapper">
        {/* here we are rendering the stars rating to the screen */}
        {renderedAvgRating}
      </fieldset>
    </div>
  );
};


StarRating.propTypes = {
  data: PropTypes.string,
  className: PropTypes.string,
};

export default StarRating;